<!--<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="showCalculationEntries">
  <kendo-panelbar #panelbar>
    <kendo-panelbar-item 
                         [expanded]="true">
      <ng-template kendoPanelBarItemTitle>
        <span>{{thermalCalculatorTxt.selectionsPanelLbl?thermalCalculatorTxt.selectionsPanelLbl:thermalCalculator.selectionsPanelLbl}}</span>
        <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
              *ngIf="!thermalCalculator.isSelectionPanelValid && thermalCalculator.isSubmitted"></span>
        <span class="k-icon k-i-check-circle k-i-checkmark-circle"
              *ngIf="thermalCalculator.isSelectionPanelValid && thermalCalculator.isSubmitted"
              style="color:green;font-weight:600"></span>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <form [formGroup]="thermalCalculatorForm">
          <div class="row m-top">
            <div class="col-sm-1"></div>
            <div class="col-sm-10">

              <div class="row">
                <div class="col-sm-6">
                  <h6>{{thermalCalculatorTxt.systemSelectionLbl?thermalCalculatorTxt.systemSelectionLbl:thermalCalculator.systemSelectionLbl}}</h6>
                  <div class="form-group">
                    <label class="lbl">{{thermalCalculatorTxt.projectNameLbl?thermalCalculatorTxt.projectNameLbl:thermalCalculator.projectNameLbl}}<span class="requiredField">*</span></label>
                    <input type="text" kendoTextBox formControlName="projectName"
                           class="kendoInput" [ngClass]="{'borderRed':thermalCalculator.isEmptyProjectName && thermalCalculator.isSubmitted}"
                           (blur)="validateThermalCalculatorForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lbl">{{thermalCalculatorTxt.projectLocationLbl?thermalCalculatorTxt.projectLocationLbl:thermalCalculator.projectLocationLbl}}<span class="requiredField">*</span></label>
                    <input type="text" kendoTextBox formControlName="projectLocation"
                           class="kendoInput" [ngClass]="{'borderRed':thermalCalculator.isEmptyProjectLocation && thermalCalculator.isSubmitted}"
                           (blur)="validateThermalCalculatorForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lbl">{{thermalCalculatorTxt.productTypeLbl?thermalCalculatorTxt.productTypeLbl:thermalCalculator.productTypeLbl}}<span class="requiredField">*</span></label>
                    <kendo-dropdownlist class="kendoInput" formControlName="productType"
                                        [data]="productTypeData" (selectionChange)="productTypeChange($event)"
                                        textField="productType" valueField="productType"
                                        [ngClass]="{'borderRed':thermalCalculator.isEmptyProductType && thermalCalculator.isSubmitted}"
                                        [valuePrimitive]="true"
                                        (blur)="validateThermalCalculatorForm()"
                                        [filterable]="true" (focus)="handleProductTypeFilter($event)"
                                   (filterChange)="handleProductTypeFilter($event)">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <label class="lbl">{{thermalCalculatorTxt.productSeriesLbl?thermalCalculatorTxt.productSeriesLbl:thermalCalculator.productSeriesLbl}}<span class="requiredField">*</span></label>
                    <kendo-dropdownlist class="kendoInput" formControlName="productSeries"
                                        [ngModel]="{name:selectedProductSeries,value:selectedProductSeriesId}"
                                        [data]="productSeriesData"
                                        textField="productSeries" valueField="productSeries"
                                        [ngClass]="{'borderRed':thermalCalculator.isEmptyProductSeries&& thermalCalculator.isSubmitted}"
                                        (blur)="validateThermalCalculatorForm()"
                                        [filterable]="true" (focus)="handleProductSeriesFilter($event)"
                                   (filterChange)="handleProductSeriesFilter($event)">
                    </kendo-dropdownlist>
                  </div>
                </div>
                <div class="col-sm-6">
                  <h6>{{thermalCalculatorTxt.customerGlazingInfoLbl?thermalCalculatorTxt.customerGlazingInfoLbl:thermalCalculator.customerGlazingInfoLbl}}</h6>
                  <div class="form-group">
                    <label class="lbl">{{thermalCalculator.ufactorLbl}}<span class="requiredField">*</span></label>
                    <kendo-dropdownlist class="kendoInput" formControlName="ufactor" [ngModel]="{name:selectedUfactor,value:selectedUfactorId}" [data]="ufactorData"
                                        textField="uFactor" valueField="uFactor"
                                        [ngClass]="{'borderRed':thermalCalculator.isEmptyUfactor && thermalCalculator.isSubmitted}"
                                        (blur)="validateThermalCalculatorForm()">
[filterable]="true" (focus)="handleUFactorFilter($event)"
(filterChange)="handleUFactorFilter($event)"
</kendo-dropdownlist>
</div>
<div class="form-group">
  <label class="lbl">{{thermalCalculatorTxt.solarHeatLbl?thermalCalculatorTxt.solarHeatLbl:thermalCalculator.solarHeatLbl}}<span class="requiredField">*</span></label>
  <kendo-dropdownlist class="kendoInput" formControlName="solarHeat" [ngModel]="{name:selectedSolarHeat,value:selectedSolarHeatId}" [data]="SolarHeatData"
                      textField="solarHeatGainCoefficient" valueField="solarHeatGainCoefficient"
                      [ngClass]="{'borderRed':thermalCalculator.isEmptySolarHeat&& thermalCalculator.isSubmitted}"
                      (blur)="validateThermalCalculatorForm()">
[filterable]="true" (focus)="handleSolarHeatFilter($event)"
(filterChange)="handleSolarHeatFilter($event)"
</kendo-dropdownlist>
    </div>
    <div class="form-group">
      <label class="lbl">{{thermalCalculatorTxt.visibleTransmittanceLbl?thermalCalculatorTxt.visibleTransmittanceLbl:thermalCalculator.visibleTransmittanceLbl}}<span class="requiredField">*</span></label>
      <kendo-dropdownlist class="kendoInput" formControlName="visibleTransmittance" [ngModel]="{name:selectedVisibleTransmittance,value:selectedVisibleTransmittanceId}" [data]="visibleTransmittanceData"
                          textField="visibleTransmittance" valueField="visibleTransmittance" [ngClass]="{'borderRed':thermalCalculator.isEmptyVisibleTransmittance&& thermalCalculator.isSubmitted}" (blur)="validateThermalCalculatorForm()">
      </kendo-dropdownlist>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-6">
    <div class="form-group">
      <div class="mb-3">
testTypeVal ,projectSizeVisionVal ,projectSizeDimensionVal
<input type="radio" kendoRadioButton value="0" formControlName="sizeCategory" (click)="toggle('testType')" [checked]="thermalCalculator.testTypeSelected" />
    <label class="k-checkbox-label" for="ch1">{{thermalCalculatorTxt.testSizeLbl?thermalCalculatorTxt.testSizeLbl:thermalCalculator.testSizeLbl}}</label>
  </div>

  <div class="mb-3">
    <input type="radio" kendoRadioButton value="1" formControlName="sizeCategory" (click)="toggle('projectSizeVision')" [checked]="thermalCalculator.projectSizeVisionSelected" />

    <label class="k-checkbox-label" for="ch2">{{thermalCalculatorTxt.projectSizeVisionLbl?thermalCalculatorTxt.projectSizeVisionLbl:thermalCalculator.projectSizeVisionLbl}}</label>
  </div>
  <div class="mb-3">
    <input type="radio" kendoRadioButton value="2" formControlName="sizeCategory" (click)="toggle('projectSizeDimension')" [checked]="thermalCalculator.projectSizeDimensionSelected" />

    <label class="k-checkbox-label" for="ch3">{{thermalCalculatorTxt.projectSizeDimensionLbl?thermalCalculatorTxt.projectSizeDimensionLbl:thermalCalculator.projectSizeDimensionLbl}}</label>
  </div>
</div>
<div class="form-group" *ngIf="isProjectSizeVisionSelected">
  <label class="lbl">{{thermalCalculatorTxt.visibleAreaLbl?thermalCalculatorTxt.visibleAreaLbl:thermalCalculator.visibleAreaLbl}}<span class="requiredField">*</span></label>
  <kendo-numerictextbox class="kendoInput" name="visibleArea" formControlName="visibleArea" [decimals]="0"
                        [format]="'#'" [spinners]="false"
                        [ngClass]="{'borderRed':thermalCalculator.isEmptyvisibleArea && newUserDialog.thermalCalculator}"></kendo-numerictextbox>
 Give maxlength
</div>
                  <div class="form-group" *ngIf="isProjectSizeDimensionSelected">
                    <h6>{{thermalCalculatorTxt.jobSpecificationLbl?thermalCalculatorTxt.jobSpecificationLbl:thermalCalculator.jobSpecificationLbl}}</h6>
                    <div>
                      <p>
                        {{thermalCalculatorTxt.jobSpecificationMsg?thermalCalculatorTxt.jobSpecificationMsg:thermalCalculator.jobSpecificationMsg}}
                      </p>
                    </div>
                    <div *ngIf="hasProjectSizeDimensionImage">
                      <img imageLoader [src]="thermalCalculatorResource?.ProjectSizeDimensionImage" *ngIf="thermalCalculatorResource?.ProjectSizeDimensionImage" alt="image" style="height:250px;width:250px;" />
                    </div>
                    <br />
                    <div class="form-group row">
                      <div class="col">
                        <div *ngIf="totalOfVerticalData?.length>0">
                          <label class="lbl">{{thermalCalculatorTxt.totalOfVerticalLbl?thermalCalculatorTxt.totalOfVerticalLbl:thermalCalculator?.totalOfVerticalLbl}}<span class="requiredField">*</span></label>
                          <kendo-dropdownlist class="kendoInput"
                                              formControlName="totalOfVertical"
                                              [data]="totalOfVerticalData"
                                              textField="name" valueField="value"
                                              (selectionChange)="verticalSelectionChange($event)"
                                              (valueChange)="verticalSelectionChange($event)"
                                              (change)="verticalSelectionChange($event)"
                                              [valuePrimitive]="true"
                                              [ngClass]="{'borderRed':thermalCalculator?.isEmptyTotalOfVertical && thermalCalculator?.isSubmitted}">
                          </kendo-dropdownlist>
                        </div>
                      </div>
                      <div class="col">
                        <div *ngIf="totalOfHorizontalData?.length>0">
                          <label class="lbl">{{thermalCalculatorTxt.totalOfHorizontalLbl?thermalCalculatorTxt.totalOfHorizontalLbl:thermalCalculator?.totalOfHorizontalLbl}}<span class="requiredField">*</span></label>
                          <kendo-dropdownlist class="kendoInput" formControlName="totalOfHorizontal"
                                              [data]="totalOfHorizontalData"
                                              (valueChange)="horizontalSelectionChange($event)"
                                              (change)="horizontalSelectionChange($event)"
                                              (selectionChange)="horizontalSelectionChange($event)"
                                              textField="name" valueField="value"
                                              [valuePrimitive]="true"
                                              [ngClass]="{'borderRed':thermalCalculator?.isEmptyTotalOfHorizontal && thermalCalculator?.isSubmitted}">
                          </kendo-dropdownlist>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-1"></div>

          </div>
          <div *ngIf="thermalCalculatorResource?.productType">
            <app-project-size-dimension [thermalCalculatorResource]="thermalCalculatorResource" (thermalCalculatorResourceEvent)="receiveData($event)">
            </app-project-size-dimension>
          </div>
        </form>
        <div class="d-flex justify-content-center col-xs-12 col-sm-12">
          <button kendoButton primary="true" class="continue-button m-3"
                  (click)="continueToNextPanel()">
            {{thermalCalculatorTxt.continueLbl?thermalCalculatorTxt.continueLbl:thermalCalculator.continueLbl}}
          </button>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item title="{{thermalCalculatorTxt.termsConditionTitleLbl?thermalCalculatorTxt.termsConditionTitleLbl:thermalCalculator.termsConditionTitleLbl}}"
                         [expanded]="false">
      <ng-template kendoPanelBarContent>
        <div class="row m-top">
          <div class="col-sm-1"></div>
          <div class="col-sm-10">
            <div class="col-xs-12 col-sm-12 m-top">
              <div class="form-group">
                <span>{{thermalCalculatorTxt.termsConditionContentLbl?thermalCalculatorTxt.termsConditionContentLbl:thermalCalculator.termsConditionContentLbl}}</span>
              </div>
              <div class="form-group">
                <kendo-switch [(ngModel)]="termsChecked" name="toggle" onLabel="Yes" offLabel="No">
                </kendo-switch>
                <label [for]="termsConditions" class="lblCheck">{{thermalCalculatorTxt.acceptTermsConditionLbl?thermalCalculatorTxt.acceptTermsConditionLbl:thermalCalculator.acceptTermsConditionLbl}} </label>
              </div>
              <div class="d-flex justify-content-center col-xs-12 col-sm-12" *ngIf="termsChecked">
                <button kendoButton class="m-3 btn btn-success"
                        (click)="calculate()" [disabled]="saveInProcess">
                  {{thermalCalculatorTxt.calculateLbl?thermalCalculatorTxt.calculateLbl:thermalCalculator.calculateLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
                <button kendoButton class="m-3 btn btn-success" [disabled]="saveInProcess" (click)="cancel()">{{thermalCalculatorTxt.cancelLbl?thermalCalculatorTxt.cancelLbl:thermalCalculator.cancelLbl}}</button>
              </div>
            </div>
          </div>
          <div class="col-sm-1"></div>
        </div>

      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>

<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="showCalculationTable">
  <div class="row">
    <div class="col-sm-1"></div>
    <div class="col-sm-10">
      <table class="table table-bordered table-hover">
        <tr>
          <th colspan="2">{{thermalCalculatorTxt.coglbl?thermalCalculatorTxt.coglbl:thermalCalculator.coglbl}} </th>
          <th>{{thermalCalculatorTxt.ngrcLbl?thermalCalculatorTxt.ngrcLbl:thermalCalculator.ngrcLbl}} {{list.nfrcSizeValues}}</th>
          <th>{{thermalCalculatorTxt.projectValueLbl?thermalCalculatorTxt.projectValueLbl:thermalCalculator.projectValueLbl}}</th>
        </tr>

<tbody>
          <tr>
            <td>{{thermalCalculatorTxt.ufactorLbl?thermalCalculatorTxt.ufactorLbl:thermalCalculator.ufactorLbl}}</td>
            <td>{{list.coguFactor}}</td>
            <td>{{list.nfrcuFactor}}</td>
            <td>{{list.projectValuesUFactor}}</td>
          </tr>
          <tr>
            <td>{{thermalCalculatorTxt.shgcLbl?thermalCalculatorTxt.shgcLbl:thermalCalculator.shgcLbl}}</td>
            <td>{{list.cogSolarHeatGainCoefficient}}</td>
            <td>{{list.nfrcSolarHeatGainCoefficient}}</td>
            <td>{{list.projectValuesSolarHeatGainCoefficient}}</td>
          </tr>
          <tr>
            <td>{{thermalCalculatorTxt.vtLbl?thermalCalculatorTxt.vtLbl:thermalCalculator.vtLbl}}</td>
            <td>{{list.cogVisibleTransmittance}}</td>
            <td>{{list.nfrcVisibleTransmittance}}</td>
            <td>{{list.projectValuesVisibleTransmittance}}</td>
          </tr>
          <tr>
            <td colspan="4">&nbsp;</td>
          </tr>
          <tr>
            <td colspan="2">{{thermalCalculatorTxt.visionAreaLbl?thermalCalculatorTxt.visionAreaLbl:thermalCalculator.visionAreaLbl}}:</td>
            <td>{{list.nfrcVisionArea}}</td>
            <td>{{list.projectValuesVisionArea}}</td>
          </tr>
          <tr>
            <td colspan="4">{{thermalCalculatorTxt.tableContent1Lbl?thermalCalculatorTxt.tableContent1Lbl:thermalCalculator.tableContent1Lbl}}</td>
          </tr>
          <tr>
            <td colspan="4">{{thermalCalculatorTxt.tableContent2Lbl?thermalCalculatorTxt.tableContent2Lbl:thermalCalculator.tableContent2Lbl}}: {{list.kawneerTestReportNFRC102}}</td>
          </tr>
          <tr>
            <td colspan="4">{{thermalCalculatorTxt.tableContent3Lbl?thermalCalculatorTxt.tableContent3Lbl:thermalCalculator.tableContent3Lbl}}: {{list.kawneerTestReportAMMA}}</td>
          </tr>
          <tr>
            <td colspan="4">{{thermalCalculatorTxt.tableContent4Lbl?thermalCalculatorTxt.tableContent4Lbl:thermalCalculator.tableContent4Lbl}}:{{list.kawneerTestReportNFRC}}</td>
          </tr>
          <tr>
            <td colspan="4">{{thermalCalculatorTxt.tableContent5Lbl?thermalCalculatorTxt.tableContent5Lbl:thermalCalculator.tableContent5Lbl}}: {{list.complianceCertificate}}</td>
          </tr>
        </tbody>

      </table>
      <div class="d-flex justify-content-center col-xs-12 col-sm-12">
        <button kendoButton class="m-3 btn btn-success"
                (click)="editSelection()" [disabled]="downloadInProgress">
          {{thermalCalculatorTxt.editLbl?thermalCalculatorTxt.editLbl:thermalCalculator.editLbl}}
        </button>
        <button kendoButton class="m-3 btn btn-success"
                (click)="downloadThermalCalculator(list)" [disabled]="downloadInProgress">
          {{thermalCalculatorTxt.downloadLbl?thermalCalculatorTxt.downloadLbl:thermalCalculator.downloadLbl}}<kendo-loader *ngIf="downloadInProgress" style="color:blue"></kendo-loader>
        </button>
      </div>
    </div>
    <div class="col-sm-1"></div>
  </div>

</div>-->
<div>
  <!--<iframe src='https://www.kawneer-ecommerce.com/tcu/thermal-calculator?ngsw-bypass=true' height="800" width="100%"></iframe>-->
  <iframe [src]="thermalCalculatorUrl" height="800" width="100%"></iframe>

</div>
